import * as React from 'react';
import {
  GetQueueMetadata_workspace_queueMeta,
  GetSocialProfiles_workspace_socialProfiles
} from '../../../../models/legacy-graphql';
import { GetCategoriesQuery } from '../../../../models/graphql';
import { ProfilePauseModalView, ProfilePauseModalViewProps } from './ProfilePauseModal.view';
import { OnUpdatePausePerProfileCategory, PauseStates } from '../Pause.controller';
import { SubmitHandler, useForm } from 'react-hook-form';
import { FormOptions } from 'constants/form';

export type ProfilePauseModalControllerType = {
  categories: GetCategoriesQuery['workspace']['categories'];
  profile: GetSocialProfiles_workspace_socialProfiles;
  onClose: VoidFunction;
  queueMeta: GetQueueMetadata_workspace_queueMeta[];
  onUpdatePerProfileCategory: OnUpdatePausePerProfileCategory;
  submitted: boolean;
};
export type CategoriesState = { [categoryWithId: string]: PauseStates };
export const ProfilePauseModalController = (props: ProfilePauseModalControllerType): JSX.Element => {
  const getCategoriesState = () => {
    const state: CategoriesState = {};
    props.queueMeta.forEach(item => {
      if (item.category?.id && item.socialProfile?.id === props.profile.id) {
        state['category-' + item.category.id] = item.paused ? PauseStates.Paused : PauseStates.Active;
      }
    });
    return state;
  };
  const formInstance = useForm({ ...FormOptions, defaultValues: getCategoriesState() });
  const onSubmit: SubmitHandler<CategoriesState> = data => {
    props.onUpdatePerProfileCategory(
      Object.keys(data).map(key => ({
        socialProfileId: props.profile.id,
        categoryId: key.split('-')[1],
        paused: data[key] === PauseStates.Paused
      }))
    );
  };
  const viewProps: ProfilePauseModalViewProps = {
    ...props,
    onSubmit,
    formInstance
  };
  return <ProfilePauseModalView {...viewProps} />;
};
